import { ColumnList } from "components/ColumnList"
import { ColumnListColumn } from "components/ColumnList/types"

import { DisplayPrices, Order } from "../types"

const columns: ColumnListColumn[] = [
    { header: 'Name', accessor: 'name', align: 'left', flex: 6 },
{ header: 'Local Currency Amount', accessor: 'localAmount', align: 'right', flex: 2 },
    { header: 'Amount in USD', accessor: 'usdAmount', align: 'right', flex: 1 },
]

export const PaymentDetails = ({ order, displayPrices }: { order?: Order, displayPrices: DisplayPrices | null }) => {
    if (!order || !displayPrices) return null;

    return (
        <div className="flex flex-col gap-4 p-6 pb-8 border border-base-sidebarBorder rounded-lg">
            <h2 className="font-medium text-xl text-base-primary">Payment Details</h2>
            <div className="flex flex-col gap-4">
                <ColumnList showColumns columns={columns} data={[
                    {
                        name: 'Collected',
                        localAmount: `${order.currencySymbol}${displayPrices.amountNetTotal.toFixed(2)}`,
                        usdAmount: `$${displayPrices.amountNetInDollar.toFixed(2)}`,
                        localAmountDataTestId: 'paymentDetailsCollectedLocal',
                        usdAmountDataTestId: 'paymentDetailsCollectedUsd'
                    },
                    {
                        name: 'Exchange Cost',
                        localAmount: `${order.currencySymbol}${displayPrices.currencyExchangeCost.toFixed(2)}`,
                        localAmountDataTestId: 'paymentDetailsExchangeCost'
                    },
                    {
                        name: 'Tax Amount',
                        localAmount: `${order.currencySymbol}${displayPrices.taxTotal.toFixed(2)}`,
                        usdAmount: `$${displayPrices.taxAmountInDollar.toFixed(2)}`,
                        localAmountDataTestId: 'paymentDetailsTaxAmountLocal',
                        usdAmountDataTestId: 'paymentDetailsTaxAmountUsd'
                    },
                ]} />
            </div>
        </div>
    )
}